<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <ModalFotoInspeccionComponent :load="load" 
                                                  :listFotos="listFoto"
                                                  :obModal="obModal" />
                </v-col>
            </v-row>

            <v-row dense align="center" justify="center">
                <v-col cols="12" sm="4" v-for="(v,k) in listCertificado" :key="k">
                    <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on }">
                            <v-img :src="v.foto" contain height="300px" max-height="300px" v-on="on"></v-img>
                        </template>
                        <span>
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td> <strong class="white--text body-2">Marca: </strong> </td>
                                        <td class="body-2" v-html="v.marca"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Modelo: </strong> </td>
                                        <td class="body-2" v-html="v.modelo"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Año: </strong> </td>
                                        <td class="body-2" v-html="v.anio"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Cédula: </strong> </td>
                                        <td class="body-2" v-html="v.numeroDocumento"> </td>
                                    </tr>
                                </tbody>
                            </table>
                        </span>
                    </v-tooltip>
                    <div class="text-center">
                        <h3 class="headline">Placa: {{ v.placa }}</h3>
                    </div>
                    <v-btn block rounded dark color="primary" @click="ver(v)">ver Fotos</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowInformeInspeccionVehiculoComponent',
        components:{
            ModalFotoInspeccionComponent: () => import('@/components/utilites/ModalFotoInspeccionComponent.vue')
        },
        props:{
            listCertificado:{
                type:Array,
                default: () => []
            }
        },
        data: () => ({
            listFoto: [],
            load:false,
            obModal:{}
        }),
        methods:{
            ver(objeto){
                var error = 'E';

                axios.post(`${BASE_URI}administrador/foto-inspeccion/listar`,{ opcion:'L', idOrdenInspeccion:objeto.idOrdenInspeccion  })
                     .then((r) =>{
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                            this.listFoto = r.data.data;
                            this.$set(this,'obModal',objeto);
                            this.load = true;
                     })
                     .catch((e) => {
                        mensajesAlerta(e, error);
                        return e;
                    });
            },
            close(){
                this.load = false;
                this.listFoto = [];
                this.obModal = {};
            }
        },
        provide(){
            return{
                close: this.close
            }
        }
    }
</script>